import { z } from 'zod';
import { CUSTOMER_SERVICE_URL } from '@/app-constants/env.constant';
import { fetchJsonWithAuthorization } from '@/utils/fetch.utils';
import { objectToEntity } from '@/utils/transform.utils';
import { type ModuleWithPermissions, ModuleWithPermissionsSchema } from '@/entities/role.entity';

// Keep ROOT_URL consistent with other admin services
const ROOT_URL = `${CUSTOMER_SERVICE_URL}/api`;
const BASE_URL = `${ROOT_URL}/modules`;

// Fetch all modules (no pagination)
export const getAllModules = async (): Promise<ModuleWithPermissions[]> => {
  const url = `${BASE_URL}`;
  const json = await fetchJsonWithAuthorization<unknown>(url);
  const modules = objectToEntity<ModuleWithPermissions[]>(z.array(ModuleWithPermissionsSchema), json);
  return modules;
};
